import CreditCards from "pages/creditCards/CreditCards";

export default CreditCards;
